import * as Api from '@ViewModels';
import { MutationScope, useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Params {
	configId: string;
	maxPerDay: number;
	forUserId?: string;
}

export function useSchedulerConfigUpdateMaxPerDayMutation({
	onSuccess,
	onError,
	scope,
}: {
	onSuccess?: (data: Api.IMeetingConfigResponse) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	scope?: MutationScope;
}) {
	const userSession = useUserSession();

	return useMutation({
		scope,
		mutationFn: async ({ configId, maxPerDay, forUserId }: Params) => {
			const queryParams: Record<string, string | number> = { maxPerDay };
			if (forUserId) {
				queryParams.forUserId = forUserId;
			}

			return userSession.webServiceHelper.callAsync<Api.IMeetingConfigResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `scheduler/config/${configId}/MaxPerDay`,
					queryParams,
				}),
				'PUT'
			);
		},
		onSuccess,
		onError,
	});
}
